import {Abogado} from "./abogado";
export class AbogadoMessage {
    usersEmails: string[];
    title: string;
    body: string;

    constructor(value: Object) {
        Object.assign(this, value);
    }

    setUsersEmailsFromAbogados(abogados: Abogado[]): void {
        this.usersEmails = abogados.map(abogado => abogado.email);
    }

    setUsersEmails(emails: string[]): void {
        this.usersEmails = emails;
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/abogado-message.ts